import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../assets/components/header";
import Footer from "../../assets/components/footer";

class Reports extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Reports</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/tee-time-requests'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    Tee Time Requests
                                </h3>
                                <p className='card-text'>
                                    View tee-time request reports.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/members'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>Members</h3>
                                <p className='card-text'>
                                    View member reports.
                                </p>
                            </div>
                        </Link>
                    </div>

                    {this.props.user.canViewConciergeReports === true && (
                        <div className='col-md-12 mb-3'>
                            <Link
                                className='card text-decoration-none h-100'
                                to='/reports/concierge'
                            >
                                <div className='card-body'>
                                    <h3 className='card-title'>Concierge</h3>
                                    <p className='card-text'>
                                        View concierge tee-time booking reports.
                                    </p>
                                </div>
                            </Link>
                        </div>
                    )}

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/app-usage'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>App Usage</h3>
                                <p className='card-text'>
                                    View app usage overview and member usage
                                    list.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/finance'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>Finance</h3>
                                <p className='card-text'>
                                    View financial reports and account
                                    summaries.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/entities'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>Entities</h3>
                                <p className='card-text'>
                                    View entity engagement reports.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/golf-clubs'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>Golf Clubs</h3>
                                <p className='card-text'>
                                    View golf club booking reports.
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default Reports;
